import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent } from "../../../StateManagement/actions";
import DrawyerNote from "../../Notes/DrawyerNote";

export const OverViewNotes: React.FC<any> = React.memo((props) => {

  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getNotesPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const [open, setOpen] = React.useState(false);
  const [notesData, setNotesData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const id = params?.id;
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [formComponent, setFormComponent] = useState<any>()
  const isMobile = IsSmallScreen();
  const resetTrigger = useSelector((state: any) => state.components?.leadNotesGrid?.resetTrigger);
  const columns: IColumns[] = [
    {
      header: "Notes",
      fieldName: "content",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",

      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },

  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {

      const form: any = <DrawyerNote
        id={id}
        control={control}
        register={register}
        noteId={row.id}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }
  }
  useEffect(() => {

    const getNotes = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('notes/lead', Method.GET, null, id);
        if (response.data) {
          setNotesData(response?.data || []);
        }
      }


      catch (e) {

      }
    }
    if (id) {
      getNotes();
    }
  }, [resetTrigger])
  useEffect(() => {

    const getNotes = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('notes/lead', Method.GET, null, id);
        if (response.data) {
          setNotesData(response?.data || []);
        }
      }
      catch (e) {
      }
    }
    if (id) {
      getNotes();
    }
  }, [resetLoad])
  const handleData = async (data: any) => {
    try {
      if (data?.content && id && !data?.noteId) {
        dispatch(storeDataComponent('noteSubmit', { loading: true }));
        const response = await createObject('notes', { content: data?.content, leadId: id })
        setResetLoad(true)
        reset()
        if (response && response?.message) {
          dispatch(resetDataComponent('leadNotesGrid'));
          dispatch(storeDataComponent('noteSubmit', { loading: false }));
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {
          dispatch(resetDataComponent('leadNotesGrid'));
          showMessage('Notes Created Successfully', 'success')
        }
      }
      else{
        dispatch(storeDataComponent('noteSubmit', { loading: true }));
        const response = await callAPI('notes',Method.PUT, { content: data?.content, leadId: id },data?.noteId)
        setResetLoad(true)
        reset()
        if (response && response?.message) {
          dispatch(resetDataComponent('leadNotesGrid'));
          dispatch(storeDataComponent('noteSubmit', { loading: false }));
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {
          dispatch(resetDataComponent('leadNotesGrid'));
          showMessage('Notes Updated Successfully', 'success')
        }
      }
    }
    catch (e) { }

  }

  const handleNoteClick = () => {
    const form: any = <DrawyerNote
      id={id}
      control={control}
      register={register}
      reset={reset}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}

    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }

  return (
    <Grid    >
      <Grid container spacing={2} sx={{ p: 0 }}>

        <Grid item xs={12}>
          <WSDataGrid
            id="leadNotesGrid"
            title="Notes"
            columns={columns}
            data={notesData}
            addButton={{ label: 'New', color: 'secondary', }}
            onAddButtonClick={handleNoteClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>

      {formComponent && <SwipeableDrawerForm isMobile={isMobile} anchor="right" title={'Notes'}
        openForm={open}
        formComponent={<form onSubmit={handleSubmit(handleData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

      />}


    </Grid>
  );
});
